// extracted by mini-css-extract-plugin
export default {"transaction-button-box":"TransparentButton_transaction-button-box__jblbS"};